import { parseHTML } from 'jquery';
import { requests } from './http';
import { _local } from './localStorageExtend';

export const isExistTextNotic = (platform) => {
    var token = _local.get(getTextNoticKey(platform)) || null;
    if (token != null && token != undefined) {
        return true;
    }
    return false;
}

export const AddNotic = (platform) => {
    var token = _local.get(getTextNoticKey(platform)) || null;
    if (token != null && token != undefined) {
        var json=JSON.parse(token);
        var noticcontent='<div class="tagDanger" style="margin-bottom: 5px; padding: 8px;"><div><span id="notic">{content} {hrefdiv}</span></div></div>';
        noticcontent= noticcontent.replace("{content}",json.Content);
        var href=''
        if(json.ConentHrefText!=""&&json.ConentHrefText!=null&&json.ConentHrefText!=undefined)
        {
           href='<a class="defColor" href="'+json.ContentHrefUrl+'" target="_blank">'+json.ConentHrefText+'</a>'; 
        }
        noticcontent= noticcontent.replace(" {hrefdiv}",href);
        strToHtml(noticcontent);
    }

}

export const strToHtml = (str)=>{
    var div = document.getElementById('notic_show');
    console.log(str);
    div.innerHTML = str;
    return div.firstchild;
}

export const getTextNoticKey = (platform) => {
    var key = "notic_content" + platform;
    return key;
}

export const requestNotic = (platform) => {
    var key = getTextNoticKey(platform);
    var systemPlatform = "ShopPC";
    try {
       
        if(isExistTextNotic(platform))
        {
            AddNotic(platform);
            return;
        }
        //不能是异步
        requests({
            url: "/Common/GetNewNotic",
            data: { SystemPlatform: systemPlatform, Platform: platform },
            success: (json) => {
                if (json.Success) {
                     if(json.Data.NoticInfo!=null)
                     {
                       //存储token信息
                       const endtime = new Date(new Date().toLocaleDateString() + " 23:59:59").getTime()
                       _local.set(key,JSON.stringify(json.Data.NoticInfo),endtime);
                        AddNotic(platform);
                     }
                }
            }
        });
    } catch (ee) {
        console.log("requestNotic error:" + ee);
    }
}


// WEBPACK FOOTER //
// ./src/utils/notic.js